export function getConflictTypeColor(type: string) {
  switch (type) {
    case 'duplicate':
      return 'warning'
    case 'validation_error':
      return 'error'
    case 'server_error':
      return 'error'
    case 'data_conflict':
      return 'info'
    default:
      return 'default'
  }
}
